import * as $$Array from "bs-platform/lib/es6/array.js";
var unwrap = $$Array.to_list;
var wrap = $$Array.of_list;
export { unwrap, wrap };
/* No side effect */